module.exports = __webpack_public_path__ + "img/blockchain_saidao_intro.d1086022.png";